// Plik generowany automatycznie z krzyzowki/interakcja.js.
// Nie edytowac recznie.

/*
 * Zachowanie arkusza krzyzowek po stronie przegladarki.
 *
 * Ten plik jest zrodlem prawdy dla dwoch odbiorcow:
 *   - samodzielnego pliku HTML z generatora (wstrzykiwany jako <script>),
 *   - komponentow React w serwisach (dangerouslySetInnerHTML nie wykonuje
 *     <script>, wiec tam ten sam kod uruchamia useEffect).
 * Dzieki temu obie wersje zachowuja sie identycznie.
 *
 * Funkcja podlacza sie do jednego korzenia (element .krz albo document.body)
 * i zwraca funkcje odpinajaca - potrzebna Reactowi przy odmontowaniu.
 */
function podlaczKrzyzowki(korzen) {
  var PROG_MALEGO_EKRANU = 720;

  // Haslo wybrane klikiem w opis: {numer, kierunek}. Gdy jest wybrane, kierunek
  // pisania jest znany od pierwszej litery - to pewniejsza droga niz zgadywanie
  // z ruchu kursora, bo uzytkownik sam wskazal, ktore haslo wypelnia.
  var wybrane = null;

  // Kierunek wywnioskowany z ruchu po siatce - dla pisania bez wyboru hasla.
  var kierunek = null;
  var poprzednie = null;

  // --- pomocnicze ----------------------------------------------------------

  function polaHasla(tabela, numer, kier) {
    var atrybut = kier === 'poziomo' ? 'data-h' : 'data-v';
    return Array.prototype.slice.call(
      tabela.querySelectorAll('input[' + atrybut + '="' + numer + '"]')
    );
  }

  function polaHaslaZKratki(pole, kier) {
    var atrybut = kier === 'poziomo' ? 'data-h' : 'data-v';
    var numer = pole.getAttribute(atrybut);
    var tabela = pole.closest('table.siatka');
    if (!numer || !tabela) return null;
    return polaHasla(tabela, numer, kier);
  }

  // Kolejna kratka tego samego hasla. Kolejnosc w DOM jest wierszami, wiec dla
  // hasel poziomych idzie w prawo, a dla pionowych w dol - tak, jak biegnie haslo.
  function nastepnaKratka(pole, kier) {
    var lista = polaHaslaZKratki(pole, kier);
    if (!lista) return null;
    var i = lista.indexOf(pole);
    return i >= 0 && i + 1 < lista.length ? lista[i + 1] : null;
  }

  function poprzedniaKratka(pole, kier) {
    var lista = polaHaslaZKratki(pole, kier);
    if (!lista) return null;
    var i = lista.indexOf(pole);
    return i > 0 ? lista[i - 1] : null;
  }

  function mozliweKierunki(pole) {
    var wynik = [];
    if (nastepnaKratka(pole, 'poziomo')) wynik.push('poziomo');
    if (nastepnaKratka(pole, 'pionowo')) wynik.push('pionowo');
    return wynik;
  }

  // Kierunek pisania dla kratki: najpierw wybrane haslo, potem ruch kursora.
  function kierunekDla(pole) {
    if (wybrane) {
      var atrybut = wybrane.kierunek === 'poziomo' ? 'data-h' : 'data-v';
      if (pole.getAttribute(atrybut) === wybrane.numer) return wybrane.kierunek;
    }
    var mozliwe = mozliweKierunki(pole);
    if (mozliwe.length === 1) return mozliwe[0];
    if (mozliwe.length > 1 && mozliwe.indexOf(kierunek) !== -1) return kierunek;
    return null;
  }

  // --- 1. Wybor hasla klikiem w opis --------------------------------------

  function odznacz() {
    var zaznaczone = korzen.querySelectorAll('td.lit.zaznaczona');
    for (var i = 0; i < zaznaczone.length; i++) {
      zaznaczone[i].classList.remove('zaznaczona');
    }
    var wybraneOpisy = korzen.querySelectorAll('.kl.wybrany');
    for (var j = 0; j < wybraneOpisy.length; j++) {
      wybraneOpisy[j].classList.remove('wybrany');
    }
    wybrane = null;
  }

  function wybierzHaslo(opis, zFokusem) {
    var numer = opis.getAttribute('data-wpis');
    var kier = opis.getAttribute('data-kierunek');
    var tabela = opis.closest('table.siatka');
    if (numer === null || !tabela) return null;

    odznacz();
    var pola = polaHasla(tabela, numer, kier);
    for (var i = 0; i < pola.length; i++) {
      var td = pola[i].closest('td');
      if (td) td.classList.add('zaznaczona');
    }
    opis.classList.add('wybrany');
    wybrane = {numer: numer, kierunek: kier};
    kierunek = kier;

    if (zFokusem && pola.length) {
      // Zaczynamy od pierwszej pustej kratki - przy poprawianiu wpisanego
      // hasla nie ma sensu wracac na sam poczatek.
      var cel = pola[0];
      for (var k = 0; k < pola.length; k++) {
        if (!pola[k].value) { cel = pola[k]; break; }
      }
      poprzednie = cel;
      cel.focus();
      if (cel.select) cel.select();
    }
    return pola;
  }

  // --- 2. Pisanie i przeskok kursora --------------------------------------

  function zapamietajKierunek(pole) {
    if (poprzednie && poprzednie !== pole) {
      var dr = Number(pole.dataset.r) - Number(poprzednie.dataset.r);
      var dc = Number(pole.dataset.c) - Number(poprzednie.dataset.c);
      if (dr === 0 && Math.abs(dc) === 1) kierunek = 'poziomo';
      else if (dc === 0 && Math.abs(dr) === 1) kierunek = 'pionowo';
      else kierunek = null;
      // Skok w inne miejsce siatki konczy poprzednie haslo, wiec kierunek
      // przestaje obowiazywac.
    }
    poprzednie = pole;
  }

  function naFocus(e) {
    var pole = e.target;
    if (pole.classList && pole.classList.contains('litera-input') && pole.dataset.r) {
      zapamietajKierunek(pole);
      // Kratka miesci jedna litere (maxlength=1), wiec w zapelnionym polu
      // kolejne pisanie byloby ignorowane. Zaznaczenie zawartosci sprawia,
      // ze nowa litera po prostu ja zastepuje.
      if (pole.select) pole.select();
    }
  }

  function przepiszDoPaska(pole) {
    if (!pole.dataset.numer) return;
    var cel = korzen.querySelector('[data-haslo="' + pole.dataset.numer + '"]');
    if (cel) cel.value = pole.value;
  }

  function naWpis(e) {
    var pole = e.target;
    if (!pole.classList || !pole.classList.contains('litera-input')) return;

    pole.value = (pole.value || '').toUpperCase();
    przepiszDoPaska(pole);

    if (!pole.value || !pole.dataset.r) return;

    // Kierunek ustalamy takze tutaj, nie tylko przy zdarzeniu fokusu: fokus
    // bywa zawodny (przy sterowaniu programowym element.focus() zmienia
    // activeElement, ale zdarzenia focusin nie wysyla).
    zapamietajKierunek(pole);

    var kier = kierunekDla(pole);
    if (!kier) return;                            // dwuznacznie - czekamy

    var nastepne = nastepnaKratka(pole, kier);
    if (nastepne) {
      kierunek = kier;
      poprzednie = nastepne;
      nastepne.focus();
      if (nastepne.select) nastepne.select();
    }
  }

  // Backspace w pustej kratce cofa do poprzedniej litery hasla. Bez tego
  // poprawianie byloby uciazliwe: skoro kursor sam idzie do przodu, musi
  // umiec tak samo wrocic.
  function naKlawisz(e) {
    if (e.key !== 'Backspace') return;
    var pole = e.target;
    if (!pole.classList || !pole.classList.contains('litera-input')) return;
    if (pole.value) return;                       // jest co skasowac na miejscu
    var kier = kierunekDla(pole) || kierunek;
    if (!kier) return;
    var wstecz = poprzedniaKratka(pole, kier);
    if (wstecz) {
      e.preventDefault();
      wstecz.value = '';
      przepiszDoPaska(wstecz);
      poprzednie = wstecz;
      wstecz.focus();
    }
  }

  // --- 3. Powiekszony opis na malym ekranie --------------------------------

  var warstwa = null;
  var aktywna = null;

  function odmienLitery(ile) {
    var n = parseInt(ile, 10);
    if (n === 1) return 'litera';
    if (n >= 2 && n <= 4) return 'litery';
    return 'liter';
  }

  function schowaj() {
    if (warstwa) warstwa.classList.remove('widoczna');
    aktywna = null;
  }

  function pokaz(komorka) {
    var opisy = komorka.querySelectorAll('.kl[data-opis]');
    if (!opisy.length) return;
    if (!warstwa) {
      warstwa = document.createElement('div');
      warstwa.className = 'podglad-opisu';
      korzen.appendChild(warstwa);
    }
    var tresc = '';
    for (var i = 0; i < opisy.length; i++) {
      var o = opisy[i];
      var ile = o.getAttribute('data-dlugosc');
      tresc += '<div class="pozycja">'
        + '<div class="naglowek">' + o.getAttribute('data-kierunek')
        + ' · ' + ile + ' ' + odmienLitery(ile) + '</div>'
        + '<p>' + o.getAttribute('data-opis') + '</p></div>';
    }
    warstwa.innerHTML = tresc;
    warstwa.classList.add('widoczna');
    aktywna = komorka;
  }

  // --- 4. Klikniecia -------------------------------------------------------

  function naKlik(e) {
    if (!e.target.closest) return;
    var maly = window.innerWidth <= PROG_MALEGO_EKRANU;

    // Klik w warstwe: zamykamy ja i dopiero wtedy ustawiamy kursor. Na telefonie
    // klawiatura zaslonilaby opis, wiec fokus daje sie az po jego przeczytaniu.
    if (maly && e.target.closest('.podglad-opisu')) {
      var doWyboru = aktywna ? aktywna.querySelector('.kl[data-wpis]') : null;
      schowaj();
      if (doWyboru) wybierzHaslo(doWyboru, true);
      return;
    }

    var opis = e.target.closest('.kl[data-wpis]');
    if (opis) {
      // Na duzym ekranie od razu ustawiamy kursor; na malym najpierw
      // pokazujemy powiekszony opis, bo tekst w kratce jest tam drobny.
      wybierzHaslo(opis, !maly);
      if (maly) {
        var komorkaOpisu = opis.closest('td.def');
        if (komorkaOpisu === aktywna) schowaj();
        else pokaz(komorkaOpisu);
      }
      return;
    }

    var komorka = e.target.closest('td.def');
    if (komorka) {
      if (maly) {
        if (komorka === aktywna) schowaj();
        else pokaz(komorka);
      }
      return;
    }

    if (maly) schowaj();
    // Klik w kratke do wpisania zostawia zaznaczenie hasla - zwykle chodzi
    // o poprawke jednej litery. Zaznaczenie znika dopiero poza siatka.
    if (!e.target.closest('table.siatka')) odznacz();
  }

  korzen.addEventListener('input', naWpis);
  korzen.addEventListener('focusin', naFocus);
  korzen.addEventListener('keydown', naKlawisz);
  // Klikniecia sledzimy na calym dokumencie: dotkniecie strony poza
  // krzyzowkami tez ma zamykac warstwe i zdejmowac zaznaczenie.
  document.addEventListener('click', naKlik);

  return function odepnij() {
    korzen.removeEventListener('input', naWpis);
    korzen.removeEventListener('focusin', naFocus);
    korzen.removeEventListener('keydown', naKlawisz);
    document.removeEventListener('click', naKlik);
    if (warstwa && warstwa.parentNode) warstwa.parentNode.removeChild(warstwa);
    warstwa = null;
    aktywna = null;
    wybrane = null;
  };
}

export { podlaczKrzyzowki };
